import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import api from '../services/api'
import SortableTh, { sortRows } from '../components/SortableTh'
import Paginacao, { usePaginacao } from '../components/Paginacao'
import EditorCorpoEmail from '../components/EditorCorpoEmail'
import { TAGS_EMAIL, TAG_GENERO } from '../utils/emailTags'
import { useAuth } from '../contexts/AuthContext'
import { useConfig } from '../contexts/ConfigContext'
import { aplicarCorPrimaria } from '../utils/cor'
import IconExcluir from '../components/icons/IconExcluir'
import IconEditar from '../components/icons/IconEditar'
import { avisar, confirmar } from '../components/Avisos'

const PRIMARY = 'var(--primary)'

export default function Cadastro() {
  const [searchParams, setSearchParams] = useSearchParams()
  const { ehGestor: ehAdmin, temAcesso } = useAuth()
  const abas = [
    { key: 'seguradoras', label: 'Seguradoras', modulo: 'cad_seguradoras' },
    { key: 'ramos',       label: 'Ramos',       modulo: 'cad_ramos' },
    { key: 'coberturas',  label: 'Coberturas',  modulo: 'cad_coberturas' },
    { key: 'comissao',    label: 'Comissão',    modulo: 'cad_comissao' },
    { key: 'financeiro',  label: 'Financeiro',  modulo: 'cad_financeiro' },
    { key: 'emails',      label: 'Modelos de E-mail', modulo: 'cad_emails' },
    ...(ehAdmin ? [{ key: 'usuarios', label: 'Usuários' }] : []),
    ...(ehAdmin ? [{ key: 'corretora', label: 'Corretora' }] : []),
    ...(ehAdmin ? [{ key: 'log', label: 'Log de Auditoria' }] : []),
  ].filter(t => !t.modulo || temAcesso(t.modulo))
  // Aba pedida na URL sem acesso (ou sem ?tab=) cai na primeira aba liberada.
  const abaPedida = searchParams.get('tab')
  const aba = abas.some(t => t.key === abaPedida) ? abaPedida : abas[0]?.key

  const setAba = (tab) => setSearchParams({ tab })

  return (
    <>
      <div style={{ padding: '32px 24px 0' }}>
        <h2 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>Cadastros</h2>
        <div style={{ fontSize: 13, color: '#888', marginTop: 4, marginBottom: 20 }}>
          Gerencie seguradoras, ramos e coberturas do sistema.
        </div>
        <div style={{ display: 'flex', gap: 4, borderBottom: `2px solid #eee`, marginBottom: 0 }}>
          {abas.map(t => (
            <button key={t.key} onClick={() => setAba(t.key)} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '8px 18px', fontSize: 13, fontWeight: 600,
              fontFamily: 'Manrope, sans-serif',
              color: aba === t.key ? PRIMARY : '#666',
              borderBottom: aba === t.key ? `2px solid ${PRIMARY}` : '2px solid transparent',
              marginBottom: -2, transition: 'color 0.15s',
            }}>{t.label}</button>
          ))}
        </div>
      </div>
      <div className="page-content" style={{ paddingTop: 16 }}>
        {aba === 'seguradoras' && <TabSeguradoras />}
        {aba === 'ramos'       && <TabRamos />}
        {aba === 'coberturas'  && <TabCoberturas />}
        {aba === 'comissao'    && <TabComissaoParametros />}
        {aba === 'financeiro'  && <TabFinanceiroCadastro />}
        {aba === 'emails'      && <TabEmailTemplates />}
        {aba === 'usuarios' && ehAdmin && <TabUsuarios />}
        {aba === 'corretora' && ehAdmin && <TabCorretora />}
        {aba === 'log' && ehAdmin && <TabLogAuditoria />}
      </div>
    </>
  )
}

const ESTADOS = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO']
const TIPOS_TEL = ['Central Segurado','Whatsapp','Central Corretor','Observação']
const TIPOS_LINK = ['Sinistro','Vidros','Assistência']

const initSeg = {
  nome: '', abreviacao: '', gerente_nome: '', gerente_telefone: '', gerente_email: '',
  sucursal: '', sucursal_telefone: '',
  razao_social: '', cnpj: '', rua: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '', cep: '',
  observacao: '',
  telefones: [{ numero: '', tipo: 'Central Segurado', observacao: '' }],
  links: [{ link: '', tipo: 'Sinistro', observacao: '' }],
}

// CPF ou CNPJ conforme a quantidade de digitos (Origem/Destino financeiro) — mesma de Clientes.jsx
const maskCPFCNPJ = v => {
  v = v.replace(/\D/g, '')
  if (v.length <= 11) {
    v = v.replace(/(\d{3})(\d)/, '$1.$2')
    v = v.replace(/(\d{3})(\d)/, '$1.$2')
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  } else {
    v = v.replace(/^(\d{2})(\d)/, '$1.$2')
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    v = v.replace(/\.(\d{3})(\d)/, '.$1/$2')
    v = v.replace(/(\d{4})(\d)/, '$1-$2')
  }
  return v.slice(0, 18)
}
const maskCNPJ = v => {
  v = v.replace(/\D/g, '').slice(0, 14)
  v = v.replace(/^(\d{2})(\d)/, '$1.$2')
  v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
  v = v.replace(/\.(\d{3})(\d)/, '.$1/$2')
  v = v.replace(/(\d{4})(\d)/, '$1-$2')
  return v
}
const maskPhone = v => {
  v = v.replace(/\D/g, '')
  if (v.length <= 10) { v = v.replace(/(\d{2})(\d)/, '($1) $2'); v = v.replace(/(\d{4})(\d)/, '$1-$2') }
  else { v = v.replace(/(\d{2})(\d)/, '($1) $2'); v = v.replace(/(\d{5})(\d)/, '$1-$2') }
  return v.slice(0, 15)
}
const maskCEP = v => { v = v.replace(/\D/g, ''); v = v.replace(/(\d{5})(\d)/, '$1-$2'); return v.slice(0, 9) }

const sec = title => (
  <div style={{ fontSize: 11, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.08em', margin: '20px 0 12px', paddingBottom: 6, borderBottom: `2px solid rgba(var(--primary-rgb),0.12)` }}>
    {title}
  </div>
)

// ─── TAB SEGURADORAS ──────────────────────────────────────────────────────────
function TabSeguradoras() {
  const [lista, setLista] = useState([])
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(initSeg)
  const [editId, setEditId] = useState(null)
  const [loading, setLoading] = useState(false)

  const carregar = () => api.get('/cadastro/seguradoras').then(r => setLista(r.data))
  useEffect(() => { carregar() }, [])

  const abrirNovo = () => { setForm(initSeg); setEditId(null); setModal(true) }
  const abrirEditar = s => {
    setForm({
      nome: s.nome || '', abreviacao: s.abreviacao || '',
      gerente_nome: s.gerente_nome || '', gerente_telefone: s.gerente_telefone || '', gerente_email: s.gerente_email || '',
      sucursal: s.sucursal || '', sucursal_telefone: s.sucursal_telefone || '',
      razao_social: s.razao_social || '', cnpj: s.cnpj || '',
      rua: s.rua || '', numero: s.numero || '', complemento: s.complemento || '',
      bairro: s.bairro || '', cidade: s.cidade || '', estado: s.estado || '', cep: s.cep || '',
      observacao: s.observacao || '',
      telefones: s.telefones?.length ? s.telefones : [{ numero: '', tipo: 'Central Segurado', observacao: '' }],
      links: s.links?.length ? s.links : [{ link: '', tipo: 'Sinistro', observacao: '' }],
    })
    setEditId(s.id); setModal(true)
  }

  const salvar = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const dados = { ...form, telefones: form.telefones.filter(t => t.numero?.trim()), links: form.links.filter(l => l.link?.trim()) }
      if (editId) await api.put(`/cadastro/seguradoras/${editId}`, dados)
      else await api.post('/cadastro/seguradoras', dados)
      setModal(false); carregar()
    } catch { avisar('Erro ao salvar') }
    finally { setLoading(false) }
  }

  const excluir = async (id) => {
    if (!(await confirmar('Excluir esta seguradora?'))) return
    await api.delete(`/cadastro/seguradoras/${id}`); carregar()
  }

  const setTel = (i, campo, v) => {
    const t = [...form.telefones]; t[i] = { ...t[i], [campo]: v }
    setForm({ ...form, telefones: t })
  }
  const setLink = (i, campo, v) => {
    const l = [...form.links]; l[i] = { ...l[i], [campo]: v }
    setForm({ ...form, links: l })
  }

  return (
    <>
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <span style={{ fontSize: 12, color: '#888' }}>{lista.length} seguradoras</span>
          <button className="btn btn-primary" onClick={abrirNovo}>+ Nova Seguradora</button>
        </div>
        {lista.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Nenhuma seguradora cadastrada</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
            {lista.map(s => {
              const tels = Array.isArray(s.telefones) ? s.telefones.filter(t => t.numero?.trim()) : []
              const links = Array.isArray(s.links) ? s.links.filter(l => l.link?.trim()) : []
              return (
                <div key={s.id} style={{ background: '#F9F7F6', borderRadius: 12, padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a2e' }}>{s.nome}</div>
                      {s.abreviacao && <div style={{ fontSize: 11, color: '#aaa', marginTop: 1 }}>{s.abreviacao}</div>}
                    </div>
                    <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                      <button title="Editar" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#555' }} onClick={() => abrirEditar(s)}><IconEditar size={14} /></button>
                      <button title="Excluir" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#c00' }} onClick={() => excluir(s.id)}><IconExcluir size={14} /></button>
                    </div>
                  </div>
                  <div style={{ fontSize: 12, color: '#555', display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <div>📞 Sucursal: {s.sucursal_telefone || '—'}</div>
                    <div>👤 Gerente: {s.gerente_nome || '—'}</div>
                    <div>☎️ {s.gerente_telefone || '—'}</div>
                    <div>✉️ {s.gerente_email || '—'}</div>
                  </div>
                  {(tels.length > 0 || links.length > 0) && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, paddingTop: 8, borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                      {tels.map((t, i) => (
                        <span key={i} style={{ fontSize: 12, color: '#777', display: 'flex', alignItems: 'center', gap: 4 }}>
                          {t.tipo === 'Whatsapp' ? '📱' : '📞'}
                          {t.tipo}: {t.numero}
                        </span>
                      ))}
                      {links.map((l, i) => (
                        <a key={i} href={l.link} target="_blank" rel="noreferrer"
                          style={{ fontSize: 12, color: '#777', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>
                          🔗 {l.tipo}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal" style={{ maxWidth: 780 }}>
            <div className="modal-header">
              <span className="modal-title">{editId ? 'Editar Seguradora' : 'Nova Seguradora'}</span>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            <form onSubmit={salvar}>

              {sec('Dados da Seguradora')}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Nome da Seguradora *</label>
                  <input className="form-input" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Abreviação</label>
                  <input className="form-input" value={form.abreviacao} onChange={e => setForm({ ...form, abreviacao: e.target.value })} placeholder="Ex: Bradesco" />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Nome Gerente Comercial</label>
                  <input className="form-input" value={form.gerente_nome} onChange={e => setForm({ ...form, gerente_nome: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Telefone do(a) Gerente</label>
                  <input className="form-input" value={form.gerente_telefone} onChange={e => setForm({ ...form, gerente_telefone: maskPhone(e.target.value) })} placeholder="(00) 00000-0000" maxLength={15} />
                </div>
                <div className="form-group">
                  <label className="form-label">E-mail do(a) Gerente</label>
                  <input className="form-input" type="email" value={form.gerente_email} onChange={e => setForm({ ...form, gerente_email: e.target.value })} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Sucursal</label>
                  <input className="form-input" value={form.sucursal} onChange={e => setForm({ ...form, sucursal: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Telefone Sucursal</label>
                  <input className="form-input" value={form.sucursal_telefone} onChange={e => setForm({ ...form, sucursal_telefone: maskPhone(e.target.value) })} placeholder="(00) 00000-0000" maxLength={15} />
                </div>
              </div>

              {sec('Dados para NF')}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Razão Social</label>
                  <input className="form-input" value={form.razao_social} onChange={e => setForm({ ...form, razao_social: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">CNPJ</label>
                  <input className="form-input" value={form.cnpj} onChange={e => setForm({ ...form, cnpj: maskCNPJ(e.target.value) })} placeholder="00.000.000/0000-00" maxLength={18} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px 120px', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Rua</label>
                  <input className="form-input" value={form.rua} onChange={e => setForm({ ...form, rua: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Número</label>
                  <input className="form-input" value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Complemento</label>
                  <input className="form-input" value={form.complemento} onChange={e => setForm({ ...form, complemento: e.target.value })} placeholder="Apto, Sala..." />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 60px 100px', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Bairro</label>
                  <input className="form-input" value={form.bairro} onChange={e => setForm({ ...form, bairro: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Cidade</label>
                  <input className="form-input" value={form.cidade} onChange={e => setForm({ ...form, cidade: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">UF</label>
                  <select className="form-select" value={form.estado} onChange={e => setForm({ ...form, estado: e.target.value })}>
                    <option value="">—</option>
                    {ESTADOS.map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">CEP</label>
                  <input className="form-input" value={form.cep} onChange={e => setForm({ ...form, cep: maskCEP(e.target.value) })} placeholder="00000-000" maxLength={9} />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Observação</label>
                <textarea className="form-input" rows={3} value={form.observacao} onChange={e => setForm({ ...form, observacao: e.target.value })} style={{ resize: 'vertical' }} />
              </div>

              {sec('Contatos — Telefones')}
              {form.telefones.map((t, i) => (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '160px 180px 1fr auto', gap: 8, marginBottom: 8, alignItems: 'flex-end' }}>
                  <div className="form-group" style={{ margin: 0 }}>
                    {i === 0 && <label className="form-label">Número</label>}
                    <input className="form-input" value={t.numero} onChange={e => setTel(i, 'numero', e.target.value)} placeholder="Ex: 0800 123 4567" />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    {i === 0 && <label className="form-label">Tipo</label>}
                    <select className="form-select" value={t.tipo} onChange={e => setTel(i, 'tipo', e.target.value)}>
                      {TIPOS_TEL.map(o => <option key={o}>{o}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    {i === 0 && <label className="form-label">Observação</label>}
                    <input className="form-input" value={t.observacao} onChange={e => setTel(i, 'observacao', e.target.value)} placeholder="Opcional..." />
                  </div>
                  <button type="button" onClick={() => setForm({ ...form, telefones: form.telefones.filter((_, idx) => idx !== i) })}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c00', fontSize: 16, padding: '6px 4px', alignSelf: 'flex-end' }}>✕</button>
                </div>
              ))}
              <button type="button" className="btn btn-secondary btn-sm" style={{ marginBottom: 4 }}
                onClick={() => setForm({ ...form, telefones: [...form.telefones, { numero: '', tipo: 'Central Segurado', observacao: '' }] })}>
                + Adicionar telefone
              </button>

              {sec('Contatos — Links')}
              {form.links.map((l, i) => (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 160px 1fr auto', gap: 8, marginBottom: 8, alignItems: 'flex-end' }}>
                  <div className="form-group" style={{ margin: 0 }}>
                    {i === 0 && <label className="form-label">Link</label>}
                    <input className="form-input" value={l.link} onChange={e => setLink(i, 'link', e.target.value)} placeholder="https://..." />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    {i === 0 && <label className="form-label">Tipo</label>}
                    <select className="form-select" value={l.tipo} onChange={e => setLink(i, 'tipo', e.target.value)}>
                      {TIPOS_LINK.map(o => <option key={o}>{o}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    {i === 0 && <label className="form-label">Observação</label>}
                    <input className="form-input" value={l.observacao} onChange={e => setLink(i, 'observacao', e.target.value)} placeholder="Opcional..." />
                  </div>
                  <button type="button" onClick={() => setForm({ ...form, links: form.links.filter((_, idx) => idx !== i) })}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c00', fontSize: 16, padding: '6px 4px', alignSelf: 'flex-end' }}>✕</button>
                </div>
              ))}
              <button type="button" className="btn btn-secondary btn-sm"
                onClick={() => setForm({ ...form, links: [...form.links, { link: '', tipo: 'Sinistro', observacao: '' }] })}>
                + Adicionar link
              </button>

              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24 }}>
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Salvando...' : 'Salvar Seguradora'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}

// ─── TAB RAMOS ────────────────────────────────────────────────────────────────
const colunasRamos = [
  { key: 'nome',       label: 'NOME',           get: r => r.nome || '' },
  { key: 'created_at', label: 'CADASTRADO EM',  get: r => r.created_at || '', date: true },
]

function TabRamos() {
  const [lista, setLista] = useState([])
  const [nome, setNome] = useState('')
  const [editId, setEditId] = useState(null)
  const [editNome, setEditNome] = useState('')
  const [sortCol, setSortCol] = useState(null)
  const [sortDir, setSortDir] = useState('asc')
  const toggleSort = (key) => {
    if (sortCol === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    else { setSortCol(key); setSortDir('asc') }
  }

  const carregar = () => api.get('/cadastro/ramos').then(r => setLista(r.data))
  useEffect(() => { carregar() }, [])

  const salvar = async (e) => {
    e.preventDefault()
    if (!nome.trim()) return
    await api.post('/cadastro/ramos', { nome: nome.trim() })
    setNome('')
    carregar()
  }

  const salvarEdicao = async (id) => {
    if (!editNome.trim()) return
    await api.put(`/cadastro/ramos/${id}`, { nome: editNome.trim() })
    setEditId(null)
    carregar()
  }

  const excluir = async (id) => {
    if (!(await confirmar('Excluir este ramo?'))) return
    await api.delete(`/cadastro/ramos/${id}`)
    carregar()
  }

  const ordenados = sortRows(lista, colunasRamos, sortCol, sortDir)
  const paginacao = usePaginacao(ordenados)

  return (
    <div className="card">
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <form onSubmit={salvar} style={{ display: 'flex', gap: 8, flex: 1 }}>
          <input
            className="form-input" placeholder="Nome do ramo..." value={nome}
            onChange={e => setNome(e.target.value)} style={{ maxWidth: 320 }}
          />
          <button className="btn btn-primary" type="submit">+ Adicionar</button>
        </form>
        <span style={{ fontSize: 12, color: '#888', alignSelf: 'center' }}>{lista.length} ramos</span>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              {colunasRamos.map(c => (
                <SortableTh key={c.key} colKey={c.key} sortCol={sortCol} sortDir={sortDir} onSort={toggleSort}>{c.label}</SortableTh>
              ))}
              <th style={{ textAlign: 'center' }}>AÇÕES</th>
            </tr>
          </thead>
          <tbody>
            {paginacao.itensPagina.map(r => (
              <tr key={r.id}>
                <td>
                  {editId === r.id ? (
                    <input
                      className="form-input" value={editNome}
                      onChange={e => setEditNome(e.target.value)}
                      style={{ maxWidth: 260, padding: '4px 8px' }}
                      onKeyDown={e => { if (e.key === 'Enter') salvarEdicao(r.id); if (e.key === 'Escape') setEditId(null) }}
                      autoFocus
                    />
                  ) : (
                    <span style={{ fontWeight: 500 }}>{r.nome}</span>
                  )}
                </td>
                <td style={{ color: '#888', textAlign: 'center' }}>
                  {r.created_at ? new Date(r.created_at).toLocaleDateString('pt-BR') : '—'}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                    {editId === r.id ? (
                      <>
                        <button className="btn btn-primary btn-sm" onClick={() => salvarEdicao(r.id)}>Salvar</button>
                        <button className="btn btn-secondary btn-sm" onClick={() => setEditId(null)}>Cancelar</button>
                      </>
                    ) : (
                      <>
                        <button title="Editar" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#555' }}
                          onClick={() => { setEditId(r.id); setEditNome(r.nome) }}><IconEditar size={14} /></button>
                        <button title="Excluir" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#c00' }}
                          onClick={() => excluir(r.id)}><IconExcluir size={14} /></button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            {lista.length === 0 && <tr><td colSpan={3} style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Nenhum ramo cadastrado</td></tr>}
          </tbody>
        </table>
      </div>
      <Paginacao {...paginacao} rotulo="ramo" />
    </div>
  )
}

// ─── TAB COBERTURAS ───────────────────────────────────────────────────────────
function TabCoberturas() {
  const [lista, setLista] = useState([])
  const [seguradoras, setSeguradoras] = useState([])
  const [ramos, setRamos] = useState([])
  const [form, setForm] = useState({ seguradoras: [], ramo: '', campo: '', tipo: 'lista', opcoes: '', assistencia: false })
  const [filtroSeg, setFiltroSeg] = useState('')
  const [filtroRamo, setFiltroRamo] = useState('')
  const [editando, setEditando] = useState(null)
  const [editForm, setEditForm] = useState({ campo: '', tipo: 'lista', opcoes: '', assistencia: false })
  const [sortCol, setSortCol] = useState(null)
  const [sortDir, setSortDir] = useState('asc')
  const toggleSort = (key) => {
    if (sortCol === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    else { setSortCol(key); setSortDir('asc') }
  }

  const carregar = () => api.get('/cadastro/coberturas').then(r => setLista(r.data))
  useEffect(() => {
    carregar()
    api.get('/cadastro/seguradoras').then(r => setSeguradoras(r.data))
    api.get('/cadastro/ramos').then(r => setRamos(r.data))
  }, [])

  const toggleSeguradora = (nome) => {
    setForm(f => ({
      ...f,
      seguradoras: f.seguradoras.includes(nome)
        ? f.seguradoras.filter(s => s !== nome)
        : [...f.seguradoras, nome]
    }))
  }

  const salvar = async (e) => {
    e.preventDefault()
    if (form.seguradoras.length === 0 || !form.ramo || !form.campo) return
    const opcoes = form.tipo === 'lista'
      ? form.opcoes.split('\n').map(o => o.trim()).filter(Boolean)
      : []
    // Nome sem espaco sobrando nas pontas (" Responsabilidade Civil Familiar" nao batia com a leitura do PDF).
    await api.post('/cadastro/coberturas', { ...form, campo: form.campo.trim(), opcoes })
    // Mantem seguradora(s) e ramo: normalmente se cadastram varias coberturas seguidas pros mesmos.
    setForm(f => ({ ...f, campo: '', tipo: 'lista', opcoes: '', assistencia: false }))
    carregar()
  }

  const excluir = async (id) => {
    if (!(await confirmar('Excluir esta cobertura?'))) return
    await api.delete(`/cadastro/coberturas/${id}`)
    carregar()
  }

  const abrirEdicao = (c) => {
    const opcoes = Array.isArray(c.opcoes) ? c.opcoes.join('\n') : ''
    setEditando(c)
    setEditForm({ campo: c.campo, tipo: c.tipo, opcoes, assistencia: !!c.assistencia })
  }

  const salvarEdicao = async (e) => {
    e.preventDefault()
    const opcoes = editForm.tipo === 'lista'
      ? editForm.opcoes.split('\n').map(o => o.trim()).filter(Boolean)
      : []
    await api.put(`/cadastro/coberturas/${editando.id}`, { ...editForm, opcoes })
    setEditando(null)
    carregar()
  }

  const filtrados = lista.filter(c =>
    (!filtroSeg  || c.seguradora === filtroSeg) &&
    (!filtroRamo || c.ramo === filtroRamo)
  )

  const tipoLabel = { lista: 'Lista', booleano: 'Sim/Não', numero: 'Número', moeda: 'Moeda', texto: 'Texto' }

  const colunasCoberturas = [
    { key: 'seguradora', label: 'SEGURADORA', get: c => c.seguradora || '' },
    { key: 'ramo',        label: 'RAMO',       get: c => c.ramo || '' },
    { key: 'campo',       label: 'CAMPO',      get: c => c.campo || '' },
    { key: 'tipo',        label: 'TIPO',       get: c => tipoLabel[c.tipo] || c.tipo || '' },
  ]
  const filtradosOrdenados = sortRows(filtrados, colunasCoberturas, sortCol, sortDir)
  const paginacao = usePaginacao(filtradosOrdenados)

  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
      {/* Formulário */}
      <div className="card" style={{ minWidth: 300, maxWidth: 320 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
          Nova Cobertura
        </div>
        <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div className="form-group" style={{ margin: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <label className="form-label" style={{ margin: 0 }}>Seguradoras * <span style={{ fontWeight: 400, color: '#888' }}>({form.seguradoras.length} selecionadas)</span></label>
              <div style={{ display: 'flex', gap: 6 }}>
                <button type="button" style={{ fontSize: 11, color: PRIMARY, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                  onClick={() => setForm(f => ({ ...f, seguradoras: seguradoras.map(s => s.nome) }))}>Todas</button>
                <span style={{ color: '#ccc' }}>|</span>
                <button type="button" style={{ fontSize: 11, color: '#888', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                  onClick={() => setForm(f => ({ ...f, seguradoras: [] }))}>Limpar</button>
              </div>
            </div>
            <div style={{ border: '1px solid #ddd', borderRadius: 6, maxHeight: 160, overflowY: 'auto', padding: '6px 10px', background: '#fafafa', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {seguradoras.map(s => (
                <label key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, userSelect: 'none' }}>
                  <input
                    type="checkbox"
                    checked={form.seguradoras.includes(s.nome)}
                    onChange={() => toggleSeguradora(s.nome)}
                    style={{ accentColor: PRIMARY, width: 14, height: 14, cursor: 'pointer' }}
                  />
                  {s.nome}
                </label>
              ))}
              {seguradoras.length === 0 && <span style={{ color: '#aaa', fontSize: 12 }}>Nenhuma seguradora cadastrada</span>}
            </div>
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Ramo *</label>
            <select className="form-select" value={form.ramo} onChange={e => setForm({ ...form, ramo: e.target.value })} required>
              <option value="">Selecione...</option>
              {ramos.map(r => <option key={r.id} value={r.nome}>{r.nome}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Campo *</label>
            <input className="form-input" placeholder="Ex: Casco, Franquia..." value={form.campo} onChange={e => setForm({ ...form, campo: e.target.value })} required />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Tipo</label>
            <select className="form-select" value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })}>
              <option value="lista">Lista de opções</option>
              <option value="booleano">Sim / Não</option>
              <option value="numero">Número</option>
              <option value="moeda">Moeda (R$)</option>
              <option value="texto">Texto livre</option>
            </select>
          </div>
          {form.tipo === 'lista' && (
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Opções (uma por linha)</label>
              <textarea className="form-input" rows={4} placeholder={"Opção 1\nOpção 2\nOpção 3"} value={form.opcoes} onChange={e => setForm({ ...form, opcoes: e.target.value })} style={{ resize: 'vertical' }} />
            </div>
          )}
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, userSelect: 'none' }}>
            <input type="checkbox" checked={form.assistencia} onChange={e => setForm({ ...form, assistencia: e.target.checked })} style={{ accentColor: PRIMARY, width: 14, height: 14, cursor: 'pointer' }} />
            É uma cobertura acessória (aparece como Tipo de Assistência)
          </label>
          <button className="btn btn-primary" type="submit" style={{ marginTop: 4 }}>+ Adicionar Cobertura</button>
        </form>
      </div>

      {/* Lista */}
      <div className="card" style={{ flex: 1 }}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 16, alignItems: 'center' }}>
          <select className="form-select" value={filtroSeg} onChange={e => setFiltroSeg(e.target.value)} style={{ maxWidth: 180 }}>
            <option value="">Todas as seguradoras</option>
            {[...new Set(lista.map(c => c.seguradora))].sort().map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <select className="form-select" value={filtroRamo} onChange={e => setFiltroRamo(e.target.value)} style={{ maxWidth: 160 }}>
            <option value="">Todos os ramos</option>
            {[...new Set(lista.map(c => c.ramo))].sort().map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          <span style={{ fontSize: 12, color: '#888', marginLeft: 'auto' }}>{filtrados.length} coberturas</span>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                {colunasCoberturas.map(c => (
                  <SortableTh key={c.key} colKey={c.key} sortCol={sortCol} sortDir={sortDir} onSort={toggleSort}>{c.label}</SortableTh>
                ))}
                <th style={{ textAlign: 'center' }}>AÇÕES</th>
              </tr>
            </thead>
            <tbody>
              {paginacao.itensPagina.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 500 }}>{c.seguradora}</td>
                  <td style={{ textAlign: 'center' }}>{c.ramo}</td>
                  <td style={{ textAlign: 'center' }}>{c.campo}{c.fixo && <span title="Cobertura fixa do sistema — não pode ser excluída" style={{ marginLeft: 6, fontSize: 11 }}>🔒</span>}</td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="badge badge-blue">{tipoLabel[c.tipo] || c.tipo}</span>
                    {c.assistencia && <span className="badge badge-amber" title="Aparece como Tipo de Assistência" style={{ marginLeft: 6 }}>Assistência</span>}
                  </td>
                  <td style={{ display: 'flex', gap: 4, alignItems: 'center', justifyContent: 'center' }}>
                    <button title="Editar" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#555' }}
                      onClick={() => abrirEdicao(c)}><IconEditar size={14} /></button>
                    <button title={c.fixo ? 'Cobertura fixa do sistema — não pode ser excluída' : 'Excluir'}
                      disabled={c.fixo}
                      style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', color: c.fixo ? '#ccc' : '#c00', cursor: c.fixo ? 'not-allowed' : 'pointer' }}
                      onClick={() => !c.fixo && excluir(c.id)}><IconExcluir size={14} /></button>
                  </td>
                </tr>
              ))}
              {filtrados.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Nenhuma cobertura encontrada</td></tr>}
            </tbody>
          </table>
        </div>
        <Paginacao {...paginacao} rotulo="cobertura" />
      </div>

      {/* Modal de edição */}
      {editando && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={e => { if (e.target === e.currentTarget) setEditando(null) }}>
          <div className="card" style={{ width: 380, maxWidth: '95vw' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
              Editar Cobertura
            </div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>
              <strong>{editando.seguradora}</strong> · {editando.ramo}
            </div>
            {editando.fixo && (
              <div style={{ padding: '8px 12px', background: '#FAEEDA', color: '#854F0B', borderRadius: 8, fontSize: 12, marginBottom: 12 }}>
                🔒 Cobertura fixa do sistema — o nome não pode ser alterado, mas o tipo e as opções podem ser personalizados pra essa seguradora.
              </div>
            )}
            <form onSubmit={salvarEdicao} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Campo *</label>
                <input className="form-input" value={editForm.campo} onChange={e => setEditForm({ ...editForm, campo: e.target.value })} required disabled={editando.fixo} style={editando.fixo ? { opacity: 0.6 } : undefined} />
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Tipo</label>
                <select className="form-select" value={editForm.tipo} onChange={e => setEditForm({ ...editForm, tipo: e.target.value })}>
                  <option value="lista">Lista de opções</option>
                  <option value="booleano">Sim / Não</option>
                  <option value="numero">Número</option>
                  <option value="moeda">Moeda (R$)</option>
                  <option value="texto">Texto livre</option>
                </select>
              </div>
              {editForm.tipo === 'lista' && (
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label">Opções (uma por linha)</label>
                  <textarea className="form-input" rows={4} value={editForm.opcoes} onChange={e => setEditForm({ ...editForm, opcoes: e.target.value })} style={{ resize: 'vertical' }} />
                </div>
              )}
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, userSelect: 'none' }}>
                <input type="checkbox" checked={editForm.assistencia} onChange={e => setEditForm({ ...editForm, assistencia: e.target.checked })} style={{ accentColor: PRIMARY, width: 14, height: 14, cursor: 'pointer' }} />
                É uma cobertura acessória (aparece como Tipo de Assistência)
              </label>
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                <button className="btn btn-primary" type="submit" style={{ flex: 1 }}>Salvar</button>
                <button className="btn" type="button" onClick={() => setEditando(null)} style={{ flex: 1, background: '#eee', color: '#333' }}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

// ─── TAB COMISSÃO (Parametrização de recebimento) ──────────────────────────────
// Por Seguradora+Ramo+Forma de Pagamento, define pra cada quantidade de parcelas do premio (1x a
// 12x) qual e a base de calculo e a forma de recebimento da comissao — so o cadastro/parametrizacao
// em si por enquanto (usuario nao pediu pra ligar isso na tela de Apolices ainda).
const ramosComissao = ['Acidentes Pessoais', 'Automóvel', 'Bike', 'Carta Verde', 'Condomínio', 'Empresarial', 'Equipamentos', 'Residencial', 'Responsabilidade Civil', 'Vida em Grupo', 'Vida Individual', 'Viagem']
const formasPagComissao = ['Boleto', 'Débito em Conta', 'Cartão de Crédito', 'Pix', 'Restituição']
const basesCalculoComissao = ['Prêmio Líquido', 'Prêmio Líquido + Adicional']
const formasRecebimentoComissao = ['À vista', 'Parcelada', 'Esgotamento', 'Personalizada']

function TabComissaoParametros() {
  const [seguradoras, setSeguradoras] = useState([])
  const [parametros, setParametros] = useState([])
  const [seguradora, setSeguradora] = useState('')
  const [ramo, setRamo] = useState('')
  const [formaPagamento, setFormaPagamento] = useState('')
  const [salvandoParcela, setSalvandoParcela] = useState(null)

  const carregar = () => api.get('/cadastro/parametros-comissao').then(r => setParametros(Array.isArray(r.data) ? r.data : []))
  useEffect(() => {
    carregar()
    api.get('/cadastro/seguradoras').then(r => setSeguradoras(Array.isArray(r.data) ? r.data : []))
  }, [])

  const combosConfigurados = [...new Map(parametros.map(p => [`${p.seguradora}|${p.ramo}|${p.forma_pagamento}`, p])).values()]
    .map(p => ({
      seguradora: p.seguradora, ramo: p.ramo, forma_pagamento: p.forma_pagamento,
      total: parametros.filter(x => x.seguradora === p.seguradora && x.ramo === p.ramo && x.forma_pagamento === p.forma_pagamento).length,
    }))
    .sort((a, b) => a.seguradora.localeCompare(b.seguradora) || a.ramo.localeCompare(b.ramo))

  const abrirCombo = (c) => { setSeguradora(c.seguradora); setRamo(c.ramo); setFormaPagamento(c.forma_pagamento) }

  const linhas = seguradora && ramo && formaPagamento
    ? Array.from({ length: 12 }, (_, i) => {
      const numero = i + 1
      const existente = parametros.find(p => p.seguradora === seguradora && p.ramo === ramo && p.forma_pagamento === formaPagamento && p.parcela === numero)
      return existente || { seguradora, ramo, forma_pagamento: formaPagamento, parcela: numero, base_calculo: 'Prêmio Líquido', forma_recebimento: 'À vista' }
    })
    : []

  // Alterar qualquer parcela aplica o mesmo valor em todas as parcelas ABAIXO dela tambem (ex.:
  // mudar a 5x reflete na 6x...12x, sem mexer na 1x...4x) — a maioria das vezes as parcelas
  // seguintes usam a mesma base/forma da anterior, entao evita preencher uma por uma. Cada parcela
  // continua editavel individualmente depois, caso alguma precise ser diferente.
  const salvarLinha = async (linha, campo, valor) => {
    const nova = { ...linha, [campo]: valor }
    const parcelasAbaixo = Array.from({ length: 12 - linha.parcela }, (_, i) => linha.parcela + 1 + i)
    setSalvandoParcela(parcelasAbaixo.length > 0 ? 'todas' : nova.parcela)
    try {
      const { data } = await api.post('/cadastro/parametros-comissao', nova)
      let atualizadas = [data]
      if (parcelasAbaixo.length > 0) {
        const demais = parcelasAbaixo.map(numero => {
          const existente = parametros.find(p => p.seguradora === seguradora && p.ramo === ramo && p.forma_pagamento === formaPagamento && p.parcela === numero)
          const base = existente || { seguradora, ramo, forma_pagamento: formaPagamento, parcela: numero, base_calculo: nova.base_calculo, forma_recebimento: nova.forma_recebimento }
          return { ...base, [campo]: valor }
        })
        const respostas = await Promise.all(demais.map(l => api.post('/cadastro/parametros-comissao', l)))
        atualizadas = [data, ...respostas.map(r => r.data)]
      }
      setParametros(prev => {
        let novos = prev
        for (const item of atualizadas) {
          novos = novos.filter(p => !(p.seguradora === item.seguradora && p.ramo === item.ramo && p.forma_pagamento === item.forma_pagamento && p.parcela === item.parcela))
        }
        return [...novos, ...atualizadas]
      })
    } catch (err) {
      avisar('Erro ao salvar: ' + (err.response?.data?.erro || err.message))
    } finally {
      setSalvandoParcela(null)
    }
  }

  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' }}>
      <div className="card" style={{ flex: 2, minWidth: 480 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
          Parametrização de Recebimento de Comissão
        </div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
          Escolha Seguradora, Ramo e Forma de Pagamento — depois preencha a Base de Cálculo e a Forma de Recebimento pra cada quantidade de parcelas do prêmio (1x a 12x). Cada linha salva sozinha ao mudar.
        </div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
          <div className="form-group" style={{ margin: 0, minWidth: 200 }}>
            <label className="form-label">Seguradora</label>
            <select className="form-select" value={seguradora} onChange={e => setSeguradora(e.target.value)}>
              <option value="">Selecione...</option>
              {seguradoras.map(s => <option key={s.id} value={s.nome}>{s.nome}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ margin: 0, minWidth: 180 }}>
            <label className="form-label">Ramo</label>
            <select className="form-select" value={ramo} onChange={e => setRamo(e.target.value)}>
              <option value="">Selecione...</option>
              {ramosComissao.map(r => <option key={r}>{r}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ margin: 0, minWidth: 180 }}>
            <label className="form-label">Forma de Pagamento</label>
            <select className="form-select" value={formaPagamento} onChange={e => setFormaPagamento(e.target.value)}>
              <option value="">Selecione...</option>
              {formasPagComissao.map(f => <option key={f}>{f}</option>)}
            </select>
          </div>
        </div>

        {linhas.length === 0 && (
          <div style={{ padding: 24, textAlign: 'center', color: '#aaa', background: '#f8f9fa', borderRadius: 8, fontSize: 13 }}>
            Selecione Seguradora, Ramo e Forma de Pagamento pra ver/editar as 12 parcelas.
          </div>
        )}
        {linhas.length > 0 && (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Parcela</th>
                  <th>Base de Cálculo</th>
                  <th>Forma de Recebimento</th>
                </tr>
              </thead>
              <tbody>
                {linhas.map(l => (
                  <tr key={l.parcela}>
                    <td style={{ fontWeight: 600 }}>{l.parcela}x</td>
                    <td>
                      <select className="form-select" value={l.base_calculo} onChange={e => salvarLinha(l, 'base_calculo', e.target.value)} disabled={salvandoParcela === l.parcela || salvandoParcela === 'todas'}>
                        {basesCalculoComissao.map(b => <option key={b}>{b}</option>)}
                      </select>
                    </td>
                    <td>
                      <select className="form-select" value={l.forma_recebimento} onChange={e => salvarLinha(l, 'forma_recebimento', e.target.value)} disabled={salvandoParcela === l.parcela || salvandoParcela === 'todas'}>
                        {formasRecebimentoComissao.map(f => <option key={f}>{f}</option>)}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="card" style={{ flex: 1, minWidth: 280 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
          Já configurados
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {combosConfigurados.map(c => (
            <button key={`${c.seguradora}|${c.ramo}|${c.forma_pagamento}`} type="button"
              onClick={() => abrirCombo(c)}
              style={{
                textAlign: 'left', border: '1px solid #eee',
                background: (c.seguradora === seguradora && c.ramo === ramo && c.forma_pagamento === formaPagamento) ? 'var(--primary-light)' : '#fff',
                borderRadius: 8, padding: '8px 10px', cursor: 'pointer',
              }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{c.seguradora}</div>
              <div style={{ fontSize: 11, color: '#888' }}>{c.ramo} · {c.forma_pagamento} · {c.total}/12 parcelas</div>
            </button>
          ))}
          {combosConfigurados.length === 0 && <div style={{ padding: 16, textAlign: 'center', color: '#aaa', fontSize: 12 }}>Nenhuma combinação configurada ainda.</div>}
        </div>
      </div>
    </div>
  )
}

// ─── TAB FINANCEIRO (Categorias + Origem/Destino) ──────────────────────────────
// Categorias: arvore de 3 niveis por tipo (entrada/saida) so pra organizar o relatorio — so a 3a
// subcategoria (folha) aparece pra escolher no Novo Lancamento (ver Financeiro.jsx). Origem/Destino
// e um cadastro simples (nome + CPF/CNPJ opcional) por tipo, buscado com autocomplete no lancamento.
function TabFinanceiroCadastro() {
  const [tipo, setTipo] = useState('entrada')
  const [categorias, setCategorias] = useState([])
  const [origens, setOrigens] = useState([])
  const [novoNivel1, setNovoNivel1] = useState('')
  const [novoFilhoTexto, setNovoFilhoTexto] = useState({})
  const [novoOrigem, setNovoOrigem] = useState({ nome: '', cpf_cnpj: '' })

  const carregarCategorias = () => api.get('/cadastro/categorias-financeiras').then(r => setCategorias(r.data))
  const carregarOrigens = () => api.get('/cadastro/origem-destino').then(r => setOrigens(r.data))
  useEffect(() => { carregarCategorias(); carregarOrigens() }, [])

  const categoriasTipo = categorias.filter(c => c.tipo === tipo)
  const nivel1 = categoriasTipo.filter(c => c.nivel === 1)
  const filhosDe = (paiId) => categoriasTipo.filter(c => c.categoria_pai_id === paiId)

  const adicionarNivel1 = async () => {
    if (!novoNivel1.trim()) return
    await api.post('/cadastro/categorias-financeiras', { tipo, nome: novoNivel1.trim(), nivel: 1 })
    setNovoNivel1('')
    carregarCategorias()
  }
  const adicionarFilho = async (paiId, nivel) => {
    const texto = (novoFilhoTexto[paiId] || '').trim()
    if (!texto) return
    await api.post('/cadastro/categorias-financeiras', { tipo, nome: texto, nivel, categoria_pai_id: paiId })
    setNovoFilhoTexto(f => ({ ...f, [paiId]: '' }))
    carregarCategorias()
  }
  const excluirCategoria = async (id) => {
    if (!(await confirmar('Excluir esta categoria? As subcategorias dentro dela também são excluídas.'))) return
    await api.delete(`/cadastro/categorias-financeiras/${id}`)
    carregarCategorias()
  }

  const origensTipo = origens.filter(o => o.tipo === tipo)
  const adicionarOrigem = async (e) => {
    e.preventDefault()
    if (!novoOrigem.nome.trim()) return
    try {
      await api.post('/cadastro/origem-destino', { tipo, ...novoOrigem })
    } catch (err) {
      avisar(err.response?.data?.erro || 'Erro ao salvar.', 'erro')
      return
    }
    setNovoOrigem({ nome: '', cpf_cnpj: '' })
    carregarOrigens()
  }
  const excluirOrigem = async (id) => {
    if (!(await confirmar('Excluir este registro?'))) return
    await api.delete(`/cadastro/origem-destino/${id}`)
    carregarOrigens()
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
        {[['entrada', 'Entrada'], ['saida', 'Saída']].map(([v, l]) => (
          <button key={v} type="button" className={`btn btn-sm ${tipo === v ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTipo(v)}>{l}</button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        {/* Categorias */}
        <div className="card" style={{ flex: 2, minWidth: 420 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
            Categorias — {tipo === 'entrada' ? 'Entrada' : 'Saída'}
          </div>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
            3 níveis pra organizar o relatório — só a subcategoria do 3º nível aparece pra escolher no lançamento.
          </div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <input className="form-input" placeholder="Nova categoria (nível 1)..." value={novoNivel1} onChange={e => setNovoNivel1(e.target.value)} />
            <button type="button" className="btn btn-primary btn-sm" onClick={adicionarNivel1}>+ Adicionar</button>
          </div>
          {nivel1.length === 0 && <div style={{ padding: 20, textAlign: 'center', color: '#aaa', background: '#f8f9fa', borderRadius: 8, fontSize: 13 }}>Nenhuma categoria cadastrada.</div>}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {nivel1.map(c1 => (
              <div key={c1.id} style={{ border: '1px solid #eee', borderRadius: 8, padding: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <strong style={{ fontSize: 13 }}>{c1.nome}</strong>
                  <button type="button" title="Excluir" onClick={() => excluirCategoria(c1.id)} style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', color: '#c00', cursor: 'pointer' }}><IconExcluir size={14} /></button>
                </div>
                <div style={{ marginLeft: 16, marginTop: 8 }}>
                  {filhosDe(c1.id).map(c2 => (
                    <div key={c2.id} style={{ borderLeft: '2px solid #eee', paddingLeft: 10, marginBottom: 10 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>{c2.nome}</span>
                        <button type="button" title="Excluir" onClick={() => excluirCategoria(c2.id)} style={{ width: 20, height: 20, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', color: '#c00', cursor: 'pointer' }}><IconExcluir size={14} /></button>
                      </div>
                      <div style={{ marginLeft: 14, marginTop: 6 }}>
                        {filhosDe(c2.id).map(c3 => (
                          <div key={c3.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '3px 0' }}>
                            <span className="badge badge-blue" style={{ fontWeight: 400 }}>{c3.nome}</span>
                            <button type="button" title="Excluir" onClick={() => excluirCategoria(c3.id)} style={{ width: 18, height: 18, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', color: '#c00', cursor: 'pointer' }}><IconExcluir size={12} /></button>
                          </div>
                        ))}
                        <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                          <input className="form-input" style={{ fontSize: 12, padding: '4px 8px' }} placeholder="+ subcategoria (nível 3)..." value={novoFilhoTexto[c2.id] || ''} onChange={e => setNovoFilhoTexto(f => ({ ...f, [c2.id]: e.target.value }))} />
                          <button type="button" className="btn btn-secondary btn-sm" onClick={() => adicionarFilho(c2.id, 3)}>+</button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                    <input className="form-input" style={{ fontSize: 12, padding: '4px 8px' }} placeholder="+ subcategoria (nível 2)..." value={novoFilhoTexto[c1.id] || ''} onChange={e => setNovoFilhoTexto(f => ({ ...f, [c1.id]: e.target.value }))} />
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => adicionarFilho(c1.id, 2)}>+</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Origem/Destino */}
        <div className="card" style={{ flex: 1, minWidth: 300 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
            Origem/Destino — {tipo === 'entrada' ? 'Entrada' : 'Saída'}
          </div>
          <form onSubmit={adicionarOrigem} style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
            <input className="form-input" placeholder="Nome *" value={novoOrigem.nome} onChange={e => setNovoOrigem(o => ({ ...o, nome: e.target.value }))} required />
            <input className="form-input" placeholder="CPF/CNPJ (opcional)" value={novoOrigem.cpf_cnpj} onChange={e => setNovoOrigem(o => ({ ...o, cpf_cnpj: maskCPFCNPJ(e.target.value) }))} />
            <button type="submit" className="btn btn-primary btn-sm">+ Adicionar</button>
          </form>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {origensTipo.map(o => (
              <div key={o.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 10px', background: '#f8f9fa', borderRadius: 6 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>{o.nome}</div>
                  {o.cpf_cnpj && <div style={{ fontSize: 11, color: '#888' }}>{o.cpf_cnpj}</div>}
                </div>
                <button type="button" title="Excluir" onClick={() => excluirOrigem(o.id)} style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', color: '#c00', cursor: 'pointer' }}><IconExcluir size={14} /></button>
              </div>
            ))}
            {origensTipo.length === 0 && <div style={{ padding: 16, textAlign: 'center', color: '#aaa', fontSize: 12 }}>Nenhum registro.</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

// ─── TAB MODELOS DE E-MAIL ──────────────────────────────────────────────────────
const initEmailTemplate = { nome: '', assunto: '', corpo: '' }

function TabEmailTemplates() {
  const [lista, setLista] = useState([])
  const [form, setForm] = useState(initEmailTemplate)
  const [editandoId, setEditandoId] = useState(null)

  const carregar = () => api.get('/email/templates').then(r => setLista(r.data))
  useEffect(() => { carregar() }, [])

  // Um form so, reaproveitado tanto pra criar quanto pra editar (abrirEdicao so preenche o mesmo
  // estado) — editandoId decide se salvar() faz POST (novo) ou PUT (atualiza o existente).
  const salvar = async (e) => {
    e.preventDefault()
    if (!form.nome.trim() || !form.assunto.trim() || !form.corpo.trim()) return
    if (editandoId) {
      await api.put(`/email/templates/${editandoId}`, form)
    } else {
      await api.post('/email/templates', form)
    }
    setForm(initEmailTemplate)
    setEditandoId(null)
    carregar()
  }

  const excluir = async (id) => {
    if (!(await confirmar('Excluir este modelo de e-mail?'))) return
    if (editandoId === id) { setForm(initEmailTemplate); setEditandoId(null) }
    await api.delete(`/email/templates/${id}`)
    carregar()
  }

  const abrirEdicao = (t) => { setEditandoId(t.id); setForm({ nome: t.nome, assunto: t.assunto, corpo: t.corpo }) }
  const cancelarEdicao = () => { setEditandoId(null); setForm(initEmailTemplate) }

  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
      {/* Lista (so pelo nome) — coluna estreita */}
      <div className="card" style={{ minWidth: 320, maxWidth: 360 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
          Modelos Cadastrados
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {lista.map(t => (
            <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #eee', borderRadius: 8, padding: '8px 10px' }}>
              <span style={{ fontWeight: 600, fontSize: 13, cursor: 'pointer' }} onClick={() => abrirEdicao(t)}>{t.nome}</span>
              <div style={{ display: 'flex', gap: 4 }}>
                <button title="Editar" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#555' }}
                  onClick={() => abrirEdicao(t)}><IconEditar size={14} /></button>
                <button title="Excluir" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#c00' }}
                  onClick={() => excluir(t.id)}><IconExcluir size={14} /></button>
              </div>
            </div>
          ))}
          {lista.length === 0 && <div style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Nenhum modelo de e-mail cadastrado</div>}
        </div>
      </div>

      {/* Formulário (Novo Modelo / Editar Modelo) — coluna maior */}
      <div className="card" style={{ flex: 1 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
          {editandoId ? 'Editar Modelo' : 'Novo Modelo'}
        </div>
        <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Nome do modelo *</label>
            <input className="form-input" placeholder="Ex: Envio de Apólice" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Assunto *</label>
            <input className="form-input" placeholder="Ex: Sua apólice {{seguradora}} já está disponível" value={form.assunto} onChange={e => setForm({ ...form, assunto: e.target.value })} required />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Corpo do e-mail *</label>
            <EditorCorpoEmail value={form.corpo} onChange={corpo => setForm(f => ({ ...f, corpo }))} />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <button className="btn btn-primary" type="submit" style={{ flex: editandoId ? 1 : undefined }}>
              {editandoId ? 'Salvar' : '+ Adicionar Modelo'}
            </button>
            {editandoId && (
              <button className="btn btn-secondary" type="button" onClick={cancelarEdicao} style={{ flex: 1 }}>Cancelar</button>
            )}
          </div>
        </form>
        <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid #eee' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Tags disponíveis</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {[...TAGS_EMAIL, TAG_GENERO].map(t => (
              <div key={t.tag} style={{ fontSize: 12, color: '#555' }}>
                <code style={{ background: '#f5f5f5', padding: '1px 5px', borderRadius: 4, color: PRIMARY }}>{t.tag}</code> — {t.descricao}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

// ─── TAB USUÁRIOS ─────────────────────────────────────────────────────────────
const colunasUsuarios = [
  { key: 'nome',  label: 'NOME',  get: r => r.nome || '' },
  { key: 'email', label: 'EMAIL', get: r => r.email || '' },
  { key: 'perfil', label: 'PERFIL', get: r => r.perfil || '' },
  { key: 'acesso', label: 'ACESSO', get: r => r.perfil === 'admin' || r.perfil === 'gerente' || r.modulos_permitidos == null ? 'Total' : `${r.modulos_permitidos.length} tela(s)` },
]

const initUsuario = { nome: '', email: '', perfil: 'corretor', modulos_permitidos: null }

function TabUsuarios() {
  const { usuario: usuarioLogado } = useAuth()
  const souGerente = usuarioLogado?.perfil === 'gerente'
  const [lista, setLista] = useState([])
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(initUsuario)
  const [editId, setEditId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState('')
  const [senhaGerada, setSenhaGerada] = useState(null) // { email, senha }
  const [sortCol, setSortCol] = useState(null)
  const [sortDir, setSortDir] = useState('asc')
  const [modulosDisponiveis, setModulosDisponiveis] = useState([])
  const toggleSort = (key) => {
    if (sortCol === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    else { setSortCol(key); setSortDir('asc') }
  }

  const carregar = () => api.get('/usuarios').then(r => setLista(r.data))
  useEffect(() => {
    carregar()
    api.get('/usuarios/modulos').then(r => setModulosDisponiveis(r.data))
  }, [])

  const abrirNovo = () => { setForm(initUsuario); setEditId(null); setErro(''); setModal(true) }
  const abrirEditar = (u) => { setForm({ nome: u.nome, email: u.email, perfil: u.perfil, modulos_permitidos: u.modulos_permitidos }); setEditId(u.id); setErro(''); setModal(true) }

  const alternarModulo = (chave) => {
    setForm(f => {
      const atual = Array.isArray(f.modulos_permitidos) ? f.modulos_permitidos : []
      const novo = atual.includes(chave) ? atual.filter(m => m !== chave) : [...atual, chave]
      return { ...f, modulos_permitidos: novo }
    })
  }

  // Caixa do grupo (ex.: Documentos) marca/desmarca todas as telas dele de uma vez.
  const alternarGrupo = (itens, todosMarcados) => {
    setForm(f => {
      const atual = Array.isArray(f.modulos_permitidos) ? f.modulos_permitidos : []
      const chaves = itens.map(m => m.chave)
      const novo = todosMarcados ? atual.filter(m => !chaves.includes(m)) : [...new Set([...atual, ...chaves])]
      return { ...f, modulos_permitidos: novo }
    })
  }
  const gruposModulos = Object.entries(modulosDisponiveis.reduce((acc, m) => {
    (acc[m.grupo] = acc[m.grupo] || []).push(m)
    return acc
  }, {}))

  const salvar = async (e) => {
    e.preventDefault()
    setLoading(true)
    setErro('')
    try {
      if (editId) {
        await api.put(`/usuarios/${editId}`, form)
        setModal(false)
        carregar()
      } else {
        const { data } = await api.post('/usuarios', form)
        setModal(false)
        setSenhaGerada({ email: data.email, senha: data.senhaGerada })
        carregar()
      }
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar usuário')
    } finally {
      setLoading(false)
    }
  }

  const alternarAtivo = async (u) => {
    if (!(await confirmar(`${u.ativo ? 'Desativar' : 'Ativar'} o usuário ${u.nome}?`))) return
    await api.put(`/usuarios/${u.id}`, { ativo: !u.ativo })
    carregar()
  }

  const resetarSenha = async (u) => {
    if (!(await confirmar(`Gerar uma nova senha temporária para ${u.nome}?`))) return
    const { data } = await api.post(`/usuarios/${u.id}/resetar-senha`)
    setSenhaGerada({ email: data.email, senha: data.senhaGerada })
    carregar()
  }

  const ordenados = sortRows(lista, colunasUsuarios, sortCol, sortDir)
  const paginacao = usePaginacao(ordenados)

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <span style={{ fontSize: 12, color: '#888' }}>{lista.length} usuários</span>
        <button className="btn btn-primary" onClick={abrirNovo}>+ Novo usuário</button>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              {colunasUsuarios.map(c => (
                <SortableTh key={c.key} colKey={c.key} sortCol={sortCol} sortDir={sortDir} onSort={toggleSort}>{c.label}</SortableTh>
              ))}
              <th style={{ textAlign: 'center' }}>STATUS</th>
              <th style={{ textAlign: 'center' }}>AÇÕES</th>
            </tr>
          </thead>
          <tbody>
            {paginacao.itensPagina.map(u => (
              <tr key={u.id}>
                <td style={{ fontWeight: 500, textAlign: 'center' }}>{u.nome}</td>
                <td style={{ textAlign: 'center' }}>{u.email}</td>
                <td style={{ textTransform: 'capitalize', textAlign: 'center' }}>{u.perfil}</td>
                <td style={{ fontSize: 12, color: '#666', textAlign: 'center' }}>
                  {u.perfil === 'admin' || u.perfil === 'gerente' || u.modulos_permitidos == null ? 'Total' : `${u.modulos_permitidos.length} tela(s)`}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span style={{
                    fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 6,
                    color: u.ativo ? '#1a7a1a' : '#c00',
                    background: u.ativo ? 'rgba(26,122,26,0.1)' : 'rgba(204,0,0,0.08)',
                  }}>
                    {u.ativo ? 'ATIVO' : 'INATIVO'}
                  </span>
                  {u.senha_temporaria && (
                    <span style={{ marginLeft: 6, fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 6, color: '#a06a00', background: 'rgba(160,106,0,0.1)' }}>
                      SENHA TEMPORÁRIA
                    </span>
                  )}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                    {(!souGerente || u.perfil !== 'admin') && <>
                    <button title="Editar" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#555' }}
                      onClick={() => abrirEditar(u)}><IconEditar size={14} /></button>
                    <button title="Resetar senha" style={{ width: 22, height: 22, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#555' }}
                      onClick={() => resetarSenha(u)}>🔑</button>
                    {u.id !== usuarioLogado?.id && (
                      <button title={u.ativo ? 'Desativar' : 'Ativar'} style={{ background: 'none', border: 'none', cursor: 'pointer', color: u.ativo ? '#c00' : '#1a7a1a', padding: '2px 4px' }}
                        onClick={() => alternarAtivo(u)}>{u.ativo ? '🚫' : '✅'}</button>
                    )}
                    </>}
                  </div>
                </td>
              </tr>
            ))}
            {lista.length === 0 && <tr><td colSpan={6} style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Nenhum usuário cadastrado</td></tr>}
          </tbody>
        </table>
      </div>
      <Paginacao {...paginacao} rotulo="usuário" />

      {/* Modal Novo/Editar */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={e => { if (e.target === e.currentTarget) setModal(false) }}>
          <div className="card" style={{ width: 420, maxWidth: '95vw' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
              {editId ? 'Editar Usuário' : 'Novo Usuário'}
            </div>
            {erro && <div className="alert alert-error" style={{ marginBottom: 10 }}>{erro}</div>}
            <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Nome *</label>
                <input className="form-input" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required />
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Email *</label>
                <input className="form-input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Perfil *</label>
                <select className="form-input" value={form.perfil} onChange={e => setForm({ ...form, perfil: e.target.value })}>
                  <option value="corretor">Padrão (corretor)</option>
                  <option value="gerente">Gerente (admin nível 2)</option>
                  {!souGerente && <option value="admin">Administrador</option>}
                </select>
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Acesso ao sistema</label>
                {form.perfil === 'admin' ? (
                  <div style={{ fontSize: 12, color: '#888' }}>Administrador tem acesso a tudo, sem restrição.</div>
                ) : form.perfil === 'gerente' ? (
                  <div style={{ fontSize: 12, color: '#888' }}>Gerente tem acesso a tudo, menos o Fluxo de Caixa. Não pode criar nem alterar administradores.</div>
                ) : (
                  <>
                    <div style={{ display: 'flex', gap: 14, marginBottom: 8 }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, cursor: 'pointer' }}>
                        <input type="radio" checked={form.modulos_permitidos == null}
                          onChange={() => setForm({ ...form, modulos_permitidos: null })} />
                        Acesso total
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, cursor: 'pointer' }}>
                        <input type="radio" checked={form.modulos_permitidos != null}
                          onChange={() => setForm({ ...form, modulos_permitidos: Array.isArray(form.modulos_permitidos) ? form.modulos_permitidos : [] })} />
                        Restringir acesso
                      </label>
                    </div>
                    {form.modulos_permitidos != null && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 10, background: '#f7f7f7', borderRadius: 8, maxHeight: 340, overflowY: 'auto' }}>
                        {gruposModulos.map(([grupo, itens]) => {
                          const marcados = itens.filter(m => form.modulos_permitidos.includes(m.chave)).length
                          const sozinho = itens.length === 1 && itens[0].label === grupo
                          return (
                            <div key={grupo}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
                                <input type="checkbox" checked={marcados === itens.length}
                                  ref={el => { if (el) el.indeterminate = marcados > 0 && marcados < itens.length }}
                                  onChange={() => alternarGrupo(itens, marcados === itens.length)} />
                                {grupo}
                              </label>
                              {!sozinho && (
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, padding: '4px 0 0 22px' }}>
                                  {itens.map(m => (
                                    <label key={m.chave} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5, cursor: 'pointer' }}>
                                      <input type="checkbox" checked={form.modulos_permitidos.includes(m.chave)} onChange={() => alternarModulo(m.chave)} />
                                      {m.label}
                                    </label>
                                  ))}
                                </div>
                              )}
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </>
                )}
              </div>
              {!editId && (
                <div style={{ fontSize: 12, color: '#888' }}>
                  Uma senha temporária será gerada automaticamente e exibida na próxima tela.
                </div>
              )}
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                <button className="btn btn-primary" type="submit" style={{ flex: 1 }} disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</button>
                <button className="btn" type="button" onClick={() => setModal(false)} style={{ flex: 1, background: '#eee', color: '#333' }}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Senha Gerada */}
      {senhaGerada && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="card" style={{ width: 420, maxWidth: '95vw' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
              Senha temporária gerada
            </div>
            <p style={{ fontSize: 13, color: '#555', marginTop: 0 }}>
              Anote e envie com segurança para <b>{senhaGerada.email}</b>. Essa senha não será mostrada novamente e precisará ser trocada no primeiro login.
            </p>
            <div style={{
              fontFamily: 'monospace', fontSize: 18, fontWeight: 700, letterSpacing: '0.05em',
              background: '#f5f5f5', borderRadius: 8, padding: '12px 16px', textAlign: 'center', margin: '12px 0',
            }}>
              {senhaGerada.senha}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" style={{ flex: 1 }}
                onClick={() => navigator.clipboard?.writeText(senhaGerada.senha)}>Copiar</button>
              <button className="btn" style={{ flex: 1, background: '#eee', color: '#333' }}
                onClick={() => setSenhaGerada(null)}>Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// Reduz a logo pra caber em, no maximo, 300px de largura (mantendo a proporcao) antes de mandar
// pro back — ela viaja junto com o GET publico de config (Login/Navbar), entao precisa ser leve.
function redimensionarLogo(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = reject
    reader.onload = (ev) => {
      const img = new Image()
      img.onerror = reject
      img.onload = () => {
        const escala = Math.min(1, 300 / img.width)
        const canvas = document.createElement('canvas')
        canvas.width = Math.round(img.width * escala)
        canvas.height = Math.round(img.height * escala)
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height)
        resolve(canvas.toDataURL(file.type === 'image/png' ? 'image/png' : 'image/jpeg', 0.9))
      }
      img.src = ev.target.result
    }
    reader.readAsDataURL(file)
  })
}

const maskCEPCorretora = v => {
  v = (v || '').replace(/\D/g, '')
  v = v.replace(/(\d{5})(\d)/, '$1-$2')
  return v.slice(0, 9)
}

const initCorretora = {
  nome: '', razao_social: '', cnpj: '', telefone: '', email: '', site: '',
  cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '',
  logo: null, cor_primaria: '#DD3B00', senha_master: '',
}

const initSmtp = { smtp_host: '', smtp_port: 587, smtp_secure: false, smtp_user: '', smtp_from: '', smtp_pass: '' }
const initAniversario = { aniversario_ativo: false, aniversario_template_id: '' }

function TabCorretora() {
  const { config, refreshConfig } = useConfig()
  const [form, setForm] = useState(initCorretora)
  const [loading, setLoading] = useState(false)
  const [buscandoCep, setBuscandoCep] = useState(false)
  const [erro, setErro] = useState('')
  const [salvo, setSalvo] = useState(false)

  const [formSmtp, setFormSmtp] = useState(initSmtp)
  const [smtpConfigurado, setSmtpConfigurado] = useState(false)
  const [loadingSmtp, setLoadingSmtp] = useState(false)
  const [erroSmtp, setErroSmtp] = useState('')
  const [salvoSmtp, setSalvoSmtp] = useState(false)

  const [formAniversario, setFormAniversario] = useState(initAniversario)
  const [templatesEmail, setTemplatesEmail] = useState([])
  const [loadingAniversario, setLoadingAniversario] = useState(false)
  const [erroAniversario, setErroAniversario] = useState('')
  const [salvoAniversario, setSalvoAniversario] = useState(false)

  useEffect(() => { setForm({ ...initCorretora, ...config }) }, [config])

  useEffect(() => {
    api.get('/config/corretora/smtp').then(r => {
      const d = r.data || {}
      setFormSmtp({ ...initSmtp, ...d, smtp_pass: '' })
      setSmtpConfigurado(!!d.smtp_senha_configurada)
    }).catch(() => {})
    api.get('/config/corretora/aniversario').then(r => {
      const d = r.data || {}
      setFormAniversario({ aniversario_ativo: !!d.aniversario_ativo, aniversario_template_id: d.aniversario_template_id || '' })
    }).catch(() => {})
    api.get('/email/templates').then(r => setTemplatesEmail(Array.isArray(r.data) ? r.data : [])).catch(() => {})
  }, [])

  const salvarAniversario = async (e) => {
    e?.preventDefault()
    setLoadingAniversario(true)
    setErroAniversario('')
    setSalvoAniversario(false)
    try {
      const { data } = await api.put('/config/corretora/aniversario', {
        ...formAniversario,
        aniversario_template_id: formAniversario.aniversario_template_id || null,
      })
      setFormAniversario({ aniversario_ativo: !!data.aniversario_ativo, aniversario_template_id: data.aniversario_template_id || '' })
      setSalvoAniversario(true)
    } catch (err) {
      setErroAniversario(err.response?.data?.erro || 'Erro ao salvar configuração de aniversário')
    } finally {
      setLoadingAniversario(false)
    }
  }

  const salvarSmtp = async (e) => {
    e?.preventDefault()
    setLoadingSmtp(true)
    setErroSmtp('')
    setSalvoSmtp(false)
    try {
      const { data } = await api.put('/config/corretora/smtp', formSmtp)
      setFormSmtp(f => ({ ...f, ...data, smtp_pass: '' }))
      setSmtpConfigurado(!!data.smtp_senha_configurada)
      setSalvoSmtp(true)
    } catch (err) {
      setErroSmtp(err.response?.data?.erro || 'Erro ao salvar configuração de e-mail')
    } finally {
      setLoadingSmtp(false)
    }
  }

  const escolherLogo = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    try {
      const dataUrl = await redimensionarLogo(file)
      setForm(f => ({ ...f, logo: dataUrl }))
    } catch {
      setErro('Não foi possível ler essa imagem')
    }
  }

  const mudarCor = (cor) => {
    setForm(f => ({ ...f, cor_primaria: cor }))
    aplicarCorPrimaria(cor) // preview imediato, sem esperar salvar
  }

  const buscarCep = async (cep) => {
    const raw = cep.replace(/\D/g, '')
    if (raw.length !== 8) return
    setBuscandoCep(true)
    try {
      const res = await fetch(`https://viacep.com.br/ws/${raw}/json/`)
      const data = await res.json()
      if (!data.erro) setForm(f => ({ ...f, endereco: data.logradouro, bairro: data.bairro, cidade: data.localidade, estado: data.uf }))
    } catch { /* mantem o que o usuario ja tinha digitado */ }
    finally { setBuscandoCep(false) }
  }

  const salvar = async (e) => {
    e?.preventDefault()
    setLoading(true)
    setErro('')
    setSalvo(false)
    try {
      await api.put('/config/corretora', form)
      await refreshConfig()
      setSalvo(true)
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar dados da corretora')
      aplicarCorPrimaria(config.cor_primaria) // desfaz o preview se nao salvou
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {erro && <div className="alert alert-error" style={{ marginBottom: 12 }}>{erro}</div>}
      {salvo && <div className="alert" style={{ marginBottom: 12, background: 'var(--success-light)', color: 'var(--success)' }}>Dados salvos com sucesso.</div>}
      <div style={{ display: 'grid', gridTemplateColumns: '360px 1fr', gap: 16, alignItems: 'start' }}>
        {/* ===== Coluna esquerda: Identidade Visual + Senha Master ===== */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div className="card">
          <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>
            Identidade Visual
          </div>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 18 }}>
            Usados no topo do portal e na tela de login.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="form-group" style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{
                width: 100, height: 70, borderRadius: 10, border: '1px dashed #ccc',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: '#fafafa', flexShrink: 0, overflow: 'hidden',
              }}>
                {form.logo
                  ? <img src={form.logo} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  : <span style={{ fontSize: 11, color: '#aaa' }}>Sem logo</span>}
              </div>
              <div>
                <label className="btn btn-secondary btn-sm" style={{ cursor: 'pointer', display: 'inline-block' }}>
                  Alterar logo
                  <input type="file" accept="image/*" style={{ display: 'none' }} onChange={escolherLogo} />
                </label>
                <div style={{ fontSize: 11, color: '#999', marginTop: 6 }}>PNG ou JPG, fundo transparente de preferência.</div>
              </div>
            </div>

            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Nome exibido no portal *</label>
              <input className="form-input" value={form.nome || ''} onChange={e => setForm({ ...form, nome: e.target.value })} required />
            </div>

            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Cor de destaque</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <input type="color" value={form.cor_primaria} onChange={e => mudarCor(e.target.value)}
                  style={{ width: 44, height: 36, padding: 2, border: '1px solid var(--border)', borderRadius: 7, cursor: 'pointer' }} />
                <input className="form-input" style={{ maxWidth: 100, fontFamily: 'monospace' }}
                  value={form.cor_primaria} onChange={e => mudarCor(e.target.value)} maxLength={7} />
              </div>
              <div style={{ fontSize: 11, color: '#999', marginTop: 6 }}>Usada em botões, links e destaques do sistema.</div>
            </div>
          </div>
        </div>

        {/* ===== Senha Master (09/09): segunda senha, separada do login, exigida pra excluir
            Proposta/Apolice, Sinistro, Assistencia, Financeiro e Cliente. Nunca devolvida pelo
            backend — o campo fica sempre em branco aqui; preencher so quando for definir/trocar. */}
        <div className="card">
          <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>
            Senha Master
          </div>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
            Exigida, além do login, para excluir Propostas/Apólices, Sinistros, Assistências, Financeiro e Clientes.
            {config.senha_master_configurada
              ? <span style={{ color: 'var(--success)' }}> Já está configurada.</span>
              : <span style={{ color: '#A32D2D' }}> Ainda não configurada — nenhuma exclusão será permitida até definir uma.</span>}
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">{config.senha_master_configurada ? 'Nova Senha Master (deixe em branco para manter a atual)' : 'Definir Senha Master'}</label>
            <input className="form-input" type="password" value={form.senha_master || ''} onChange={e => setForm({ ...form, senha_master: e.target.value })} minLength={6} placeholder="mínimo 6 caracteres" />
          </div>
          <button className="btn btn-primary" type="button" onClick={salvar} style={{ marginTop: 16 }} disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
        </div>

        {/* ===== Coluna direita: Dados da Corretora + E-mail (SMTP) ===== */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* ===== Dados da corretora ===== */}
        <div className="card">
          <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>
            Dados da Corretora
          </div>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 18 }}>
            Razão social, documentos e contato.
          </div>
          <div className="form-grid">
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Razão Social</label>
              <input className="form-input" value={form.razao_social || ''} onChange={e => setForm({ ...form, razao_social: e.target.value })} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">CNPJ</label>
              <input className="form-input" value={form.cnpj || ''} onChange={e => setForm({ ...form, cnpj: maskCNPJ(e.target.value) })} placeholder="00.000.000/0000-00" maxLength={18} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Telefone</label>
              <input className="form-input" value={form.telefone || ''} onChange={e => setForm({ ...form, telefone: maskPhone(e.target.value) })} placeholder="(00) 00000-0000" maxLength={15} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={form.email || ''} onChange={e => setForm({ ...form, email: e.target.value })} />
            </div>
          </div>
          <div className="form-group" style={{ marginTop: 12, marginBottom: 0 }}>
            <label className="form-label">Site</label>
            <input className="form-input" placeholder="https://" value={form.site || ''} onChange={e => setForm({ ...form, site: e.target.value })} />
          </div>

          <div style={{ fontSize: 11, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.08em', margin: '20px 0 12px', paddingBottom: 6, borderBottom: '2px solid var(--primary-light)' }}>
            Endereço
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '130px 1fr 80px 0.5fr', gap: 12 }} className="form-row-auto">
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">CEP {buscandoCep && <span style={{ color: '#888', fontWeight: 400 }}>buscando...</span>}</label>
              <input className="form-input" value={form.cep || ''} placeholder="00000-000" maxLength={9}
                onChange={e => { const v = maskCEPCorretora(e.target.value); setForm({ ...form, cep: v }); if (v.length === 9) buscarCep(v) }} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Rua</label>
              <input className="form-input" value={form.endereco || ''} onChange={e => setForm({ ...form, endereco: e.target.value })} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Número</label>
              <input className="form-input" value={form.numero || ''} onChange={e => setForm({ ...form, numero: e.target.value })} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Complemento</label>
              <input className="form-input" value={form.complemento || ''} onChange={e => setForm({ ...form, complemento: e.target.value })} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 70px', gap: 12, marginTop: 12 }} className="form-row-auto">
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Bairro</label>
              <input className="form-input" value={form.bairro || ''} onChange={e => setForm({ ...form, bairro: e.target.value })} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Cidade</label>
              <input className="form-input" value={form.cidade || ''} onChange={e => setForm({ ...form, cidade: e.target.value })} />
            </div>
            <div className="form-group" style={{ margin: 0, minWidth: 0 }}>
              <label className="form-label">Estado</label>
              <select className="form-select" value={form.estado || ''} onChange={e => setForm({ ...form, estado: e.target.value })}>
                <option value="">—</option>
                {ESTADOS.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* ===== E-mail/SMTP (10/09): antes so dava pra configurar via .env do servidor (SSH) —
            agora fica cadastrado aqui, pra trocar de provedor sem precisar de acesso ao servidor.
            Senha cifrada no banco, nunca devolvida pelo backend — campo sempre em branco;
            preencher so quando for definir/trocar. Salva separado (endpoint proprio), por isso
            tem botao de Salvar dele mesmo em vez de participar do "Salvar" geral. */}
        <div className="card">
          <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>
            E-mail (SMTP)
          </div>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
            Usado para enviar propostas/apólices por e-mail direto do sistema.
            {smtpConfigurado
              ? <span style={{ color: 'var(--success)' }}> Já está configurado.</span>
              : <span style={{ color: '#A32D2D' }}> Ainda não configurado — o envio de e-mail não vai funcionar até preencher.</span>}
          </div>
          {erroSmtp && <div className="alert alert-error" style={{ marginBottom: 12 }}>{erroSmtp}</div>}
          {salvoSmtp && <div className="alert" style={{ marginBottom: 12, background: 'var(--success-light)', color: 'var(--success)' }}>Configuração de e-mail salva.</div>}
          <div className="form-grid">
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Servidor SMTP</label>
              <input className="form-input" placeholder="smtp.gmail.com" value={formSmtp.smtp_host || ''} onChange={e => setFormSmtp({ ...formSmtp, smtp_host: e.target.value })} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Porta</label>
              <input className="form-input" value={formSmtp.smtp_port || ''} onChange={e => setFormSmtp({ ...formSmtp, smtp_port: e.target.value.replace(/\D/g, '') })} placeholder="587" maxLength={5} />
            </div>
          </div>
          <div className="form-group" style={{ margin: '12px 0 0' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: '#555', cursor: 'pointer' }}>
              <input type="checkbox" checked={!!formSmtp.smtp_secure} onChange={e => setFormSmtp({ ...formSmtp, smtp_secure: e.target.checked })} />
              Conexão segura (SSL/TLS na porta 465 — deixe desmarcado para 587/STARTTLS)
            </label>
          </div>
          <div className="form-grid" style={{ marginTop: 12 }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Usuário</label>
              <input className="form-input" value={formSmtp.smtp_user || ''} onChange={e => setFormSmtp({ ...formSmtp, smtp_user: e.target.value })} placeholder="contato@suacorretora.com.br" />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">{smtpConfigurado ? 'Nova senha (deixe em branco para manter a atual)' : 'Senha'}</label>
              <input className="form-input" type="password" value={formSmtp.smtp_pass || ''} onChange={e => setFormSmtp({ ...formSmtp, smtp_pass: e.target.value })} />
            </div>
          </div>
          <div className="form-group" style={{ margin: '12px 0 0' }}>
            <label className="form-label">Remetente exibido (opcional — se vazio, usa o Usuário)</label>
            <input className="form-input" value={formSmtp.smtp_from || ''} onChange={e => setFormSmtp({ ...formSmtp, smtp_from: e.target.value })} placeholder="Nome da Corretora <contato@suacorretora.com.br>" />
          </div>
          <button className="btn btn-primary" type="button" onClick={salvarSmtp} style={{ marginTop: 16 }} disabled={loadingSmtp}>
            {loadingSmtp ? 'Salvando...' : 'Salvar E-mail'}
          </button>
        </div>

        {/* ===== Aniversário de Cliente (11/09): dispara automaticamente (cron 1x/dia, 8h) um
            e-mail pro cliente que faz aniversario no dia, usando o modelo escolhido aqui. O
            modelo em si e criado/editado normalmente em Cadastro > Modelos de E-mail. */}
        <div className="card">
          <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>
            Aniversário de Cliente
          </div>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
            Envia automaticamente, todo dia às 8h, um e-mail de aniversário para os clientes ativos que fazem aniversário na data.
          </div>
          {erroAniversario && <div className="alert alert-error" style={{ marginBottom: 12 }}>{erroAniversario}</div>}
          {salvoAniversario && <div className="alert" style={{ marginBottom: 12, background: 'var(--success-light)', color: 'var(--success)' }}>Configuração de aniversário salva.</div>}
          <div className="form-group" style={{ margin: 0 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: '#555', cursor: 'pointer' }}>
              <input type="checkbox" checked={!!formAniversario.aniversario_ativo}
                onChange={e => setFormAniversario({ ...formAniversario, aniversario_ativo: e.target.checked })} />
              Enviar e-mail de aniversário automaticamente
            </label>
          </div>
          <div className="form-group" style={{ margin: '12px 0 0' }}>
            <label className="form-label">Modelo de e-mail</label>
            <select className="form-select" value={formAniversario.aniversario_template_id || ''}
              onChange={e => setFormAniversario({ ...formAniversario, aniversario_template_id: e.target.value })}>
              <option value="">— Selecione —</option>
              {templatesEmail.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
            </select>
            <div style={{ fontSize: 11, color: '#999', marginTop: 6 }}>
              Modelos são criados e editados em Cadastro &gt; Modelos de E-mail. Tags disponíveis: {'{{nome}}'}, {'{{primeiro_nome}}'}, {'{{cpf_cnpj}}'}.
            </div>
          </div>
          <button className="btn btn-primary" type="button" onClick={salvarAniversario} style={{ marginTop: 16 }} disabled={loadingAniversario}>
            {loadingAniversario ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
        </div>
      </div>
    </>
  )
}

const ACOES_LOG = { login: 'Login', criar: 'Criou', editar: 'Editou', excluir: 'Excluiu', 'resetar-senha': 'Resetou senha', exportar: 'Exportou' }
const ENTIDADES_LOG = { cliente: 'Cliente', apolice: 'Apólice', financeiro: 'Financeiro', usuario: 'Usuário' }
const colunasLog = [
  { key: 'created_at', label: 'Data/Hora',  get: r => r.created_at || '', date: true },
  { key: 'usuario_nome', label: 'Usuário',  get: r => r.usuario_nome || '' },
  { key: 'acao',       label: 'Ação',       get: r => ACOES_LOG[r.acao] || r.acao },
  { key: 'entidade',   label: 'Cadastro',   get: r => ENTIDADES_LOG[r.entidade] || r.entidade },
  { key: 'descricao',  label: 'Descrição',  get: r => r.descricao || '' },
]

// Auditoria LGPD (retomada em 08/09): registro focado em login + criar/editar/excluir de Clientes,
// Apólices, Financeiro e Usuários — nao e um log geral de toda acao do sistema (decisao consciente,
// custo/beneficio; ver memoria do projeto).
function TabLogAuditoria() {
  const [lista, setLista] = useState([])
  const [carregando, setCarregando] = useState(true)
  const [filtroUsuario, setFiltroUsuario] = useState('')
  const [filtroAcao, setFiltroAcao] = useState('')
  const [filtroEntidade, setFiltroEntidade] = useState('')
  const [sortCol, setSortCol] = useState('created_at')
  const [sortDir, setSortDir] = useState('desc')
  const toggleSort = (key) => {
    if (sortCol === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    else { setSortCol(key); setSortDir('asc') }
  }

  useEffect(() => {
    api.get('/log-auditoria').then(r => setLista(Array.isArray(r.data) ? r.data : [])).finally(() => setCarregando(false))
  }, [])

  const usuariosDoLog = [...new Map(lista.filter(l => l.usuario_nome).map(l => [l.usuario_nome, l])).values()]
    .map(l => l.usuario_nome).sort()

  const filtrados = lista.filter(l =>
    (!filtroUsuario || l.usuario_nome === filtroUsuario) &&
    (!filtroAcao || l.acao === filtroAcao) &&
    (!filtroEntidade || l.entidade === filtroEntidade)
  )
  const ordenados = sortRows(filtrados, colunasLog, sortCol, sortDir)
  const paginacao = usePaginacao(ordenados)

  const fmtData = (d) => d ? new Date(d).toLocaleString('pt-BR') : '—'

  return (
    <div className="card">
      <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>
        Log de Auditoria
      </div>
      <div style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>
        Login e criação/edição/exclusão de Clientes, Apólices, Financeiro e Usuários — pra rastrear quem fez o quê.
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <select className="form-select" style={{ maxWidth: 200 }} value={filtroUsuario} onChange={e => setFiltroUsuario(e.target.value)}>
          <option value="">Todos os usuários</option>
          {usuariosDoLog.map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <select className="form-select" style={{ maxWidth: 160 }} value={filtroAcao} onChange={e => setFiltroAcao(e.target.value)}>
          <option value="">Todas as ações</option>
          {Object.entries(ACOES_LOG).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <select className="form-select" style={{ maxWidth: 160 }} value={filtroEntidade} onChange={e => setFiltroEntidade(e.target.value)}>
          <option value="">Todos os cadastros</option>
          {Object.entries(ENTIDADES_LOG).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <span style={{ fontSize: 12, color: '#888', marginLeft: 'auto', alignSelf: 'center' }}>{filtrados.length} registro(s)</span>
      </div>
      {carregando ? (
        <div style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Carregando...</div>
      ) : (
        <>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  {colunasLog.map(c => (
                    <SortableTh key={c.key} colKey={c.key} sortCol={sortCol} sortDir={sortDir} onSort={toggleSort}>{c.label}</SortableTh>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginacao.itensPagina.map(l => (
                  <tr key={l.id}>
                    <td style={{ whiteSpace: 'nowrap' }}>{fmtData(l.created_at)}</td>
                    <td>{l.usuario_nome || '—'}</td>
                    <td><span className="badge badge-blue">{ACOES_LOG[l.acao] || l.acao}</span></td>
                    <td>{ENTIDADES_LOG[l.entidade] || l.entidade}</td>
                    <td>{l.descricao || '—'}</td>
                  </tr>
                ))}
                {filtrados.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Nenhum registro encontrado</td></tr>}
              </tbody>
            </table>
          </div>
          <Paginacao {...paginacao} rotulo="registro" />
        </>
      )}
    </div>
  )
}
